import React from "react";
import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import Login from "../account/Login";
import Signup from "../account/Signup";
import MblMenu from "../header/MblMenu";
import NavBar from "../header/NavBar";
import Index from "../pages";
import Careers from "../pages/Careers";
import Contact from "../pages/Contact";
import DailyProblems from "../pages/DailyProblems";
import Dashboard from "../pages/Dashboard";
import InterviewsQA from "../pages/InterviewsQA";
import Mypayments from "../pages/Mypayments";
import ProblemsCompare from "../pages/ProblemsCompare";
import Profile from "../pages/Profile";
import Quiz from "../pages/Quiz";
import Roadmap from "../pages/Roadmap";
import Shop from "../pages/Shop";
import Subscription from "../pages/Subscription";
import Wallet from "../pages/Wallet";
import SingleProduct from "../products/SingleProduct";
import Policy from "../pages/Policy";
import Terms from "../pages/Terms";
import Cancellation from "../pages/Cancellation";
import Shipping from "../pages/Shipping";

const Layout = () => {
  const isLogged = useSelector((state) => state.user.isLoggedIn);
  return (
    <>
      <NavBar />
      <section>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/subscription" element={<Subscription />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/coursedetails" element={<SingleProduct />} />
          <Route path="/courses" element={<Shop />} />
          <Route path="/quiz" element={<Quiz />} />
          <Route path="/dailyproblems" element={<DailyProblems />} />
          <Route path="/interviews" element={<InterviewsQA />} />
          <Route path="/roadmaps" element={<Roadmap />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/privacy" element={<Policy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/cancellation" element={<Cancellation />} />
          <Route path="/shipping" element={<Shipping />} />
          <Route path="/" element={isLogged ? <Dashboard /> : <Login />}>
            <Route path="/dashboard" element={<Profile />} />
            <Route path="/mywallet" element={<Wallet />} />
            <Route path="/mypayments" element={<Mypayments />} />
            <Route path="/problems" element={<ProblemsCompare />} />
          </Route>
        </Routes>
        {isLogged && <MblMenu />}
      </section>
    </>
  );
};

export default Layout;
